import { GetExcursionCalendarRequest } from '@appTypes/api.types';

export class excursionsReset {
  static readonly type = '[Excursions] Reset';
}

export class excursionsSearchPackages {
  static readonly type = '[Excursions] SearchPackages';
}

/**
 * Progressive excursion search (docs features/website/excursion-search-progressive.md R-PX2): asks the running search for its latest answer after
 * `delayMs`; the live answer replaces the core rows. Dispatching it again replaces the running poll.
 */
export class excursionsPollSearchProgress {
  static readonly type = '[Excursions] PollSearchProgress';
  constructor(
    public progressId: string,
    public delayMs: number,
    public failures = 0
  ) {}
}

export class excursionsResetSearchResult {
  static readonly type = '[Excursions] ResetSearchResult';
}

export class excursionsGetDestinationCountries {
  static readonly type = '[Excursions] GetDestinationCountries';
  constructor(public refresh = false) {}
}

/** 25.09.2026: the city / category choices of a country (Amiran: "why i dont have a filters like a city and etc") */
export class excursionsGetSearchOptions {
  static readonly type = '[Excursions] GetSearchOptions';
  constructor(public countryCode: string) {}
}

export class excursionsSetKindsFilter {
  static readonly type = '[Excursions] SetKindsFilter';
  constructor(public kinds: string[]) {}
}

/** 27.09.2026: one month of the excursions calendar, kept per parameter set (the tours calendar's pattern) */
export class excursionsLoadCalendar {
  static readonly type = '[Excursions] LoadCalendar';
  constructor(
    public params: GetExcursionCalendarRequest,
    public identifier: string
  ) {}
}
